<template style="height: 100%;">
  <div class="ExamineInvitation">
    <el-tabs v-model="activeName" class="list-cnt" @tab-click="handleClick">
      <el-tab-pane label="待处理" name="first">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" style="margin-left: 1%;">
          <el-form-item label="帖子主题">
            <el-input v-model="formInline.contentName" placeholder="请输入帖子主题"></el-input>
          </el-form-item>
          <el-form-item label="创建者">
            <el-input v-model="formInline.creator" placeholder="请输入创建者"></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker value-format="yyyy-MM-dd"  v-model="formInline.createTime" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit()">查询</el-button>
            <el-button type="primary" @click="chongzhi()">重置</el-button>
          </el-form-item>
        </el-form>

        <div style="width: 100%;height: 12px;background-color: rgb(235, 236, 237);"></div>
        <el-button type="primary" style="margin-top: 14px;margin-left: 1%;" @click="passfun(1)">通过</el-button>
        <el-button type="primary" style="margin-top: 14px;" @click="passfun(2)">不通过</el-button>
        <el-table ref="multipleTable" v-loading="loading" :data="tableData" style="width: 98%;margin-left: 1%;margin-top: 14px;" @selection-change="handleSelectionChange" :row-key="(row) => { return row.contentKey }">
          <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column prop="contentName" label="帖子主题"></el-table-column>
          <el-table-column prop="remark" label="帖子描述"></el-table-column>
          <el-table-column prop="creator" label="创建人"></el-table-column>
          <el-table-column label="系统审核状态">
            <template slot-scope="scope">
              <span v-if="scope.row.systemAuditStatus == 0">待审批</span>
              <span style="color: rgb(0, 214, 96);" v-if="scope.row.systemAuditStatus == 1">审核通过</span>
              <span style="color: red;" v-if="scope.row.systemAuditStatus == 2">审核不通过</span>
            </template>
          </el-table-column>

          
          <el-table-column label="审批状态">
            <template slot-scope="scope">
              <span v-if="scope.row.auditStatus == 0">待审批</span>
              <span style="color: rgb(0, 214, 96);" v-if="scope.row.auditStatus == 1">审核通过</span>
              <span style="color: red;" v-if="scope.row.auditStatus == 2">审核不通过</span>
            </template>
          </el-table-column>

          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column prop="createTime" label="操作">
            <template slot-scope="scope">
              <span class="w" @click="looks(scope.row)">查看</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="formInline.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>

      </el-tab-pane>

      <el-tab-pane label="往期记录" name="second">
        <el-form :inline="true" :model="formInline2" class="demo-form-inline" style="margin-left: 1%;">
          <el-form-item label="帖子主题">
            <el-input v-model="formInline2.contentName" placeholder="请输入帖子名称"></el-input>
          </el-form-item>

          <el-form-item label="创建者">
            <el-input v-model="formInline2.creator" placeholder="请输入创建者"></el-input>
          </el-form-item>

          <el-form-item label="创建时间">
            <el-date-picker value-format="yyyy-MM-dd" v-model="formInline2.createTime" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit2()">查询</el-button>
            <el-button type="primary" @click="chongzhi2()">重置</el-button>
          </el-form-item>
        </el-form>

        <el-table ref="multipleTable" v-loading="loading2" :data="tableData2" style="width: 98%;margin-left: 1%;margin-top: 14px;">
          <el-table-column prop="contentName" label="帖子主题"></el-table-column>
          <el-table-column prop="remark" label="帖子描述"></el-table-column>
          <el-table-column prop="creator" label="创建人"></el-table-column>

          <el-table-column label="审批状态">
            <template slot-scope="scope">
              <span v-if="scope.row.auditStatus == 0">待审批</span>
              <span style="color: rgb(0, 214, 96);" v-if="scope.row.auditStatus == 1">审核通过</span>
              <span style="color: red;" v-if="scope.row.auditStatus == 2">审核不通过</span>
            </template>
          </el-table-column>

          <el-table-column prop="createTime" label="创建时间"></el-table-column>

          <el-table-column prop="createTime" label="操作">
            <template slot-scope="scope">
              <span class="w" @click="looks(scope.row)">查看</span>
            </template>
          </el-table-column>

        </el-table>
        <el-pagination @current-change="handleCurrentChange2" :current-page.sync="formInline2.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts2"></el-pagination>
      </el-tab-pane>

    </el-tabs>

    <el-dialog title="帖子详情" :visible.sync="dialogVisible" width="820px" :before-close="handleClose">
      
      <p style="color: rgb(73, 73, 73);margin-left: 20px;">
        帖子主题: 
        <span style="color: #000;font-weight: 700;">{{ looksdata.contentName }}</span>
      </p>

      <p style="color: rgb(73, 73, 73);margin-top: 20px;margin-left: 20px;">
        帖子说明: 
        <span style="color: #000;font-weight: 700;line-height: 24px;">{{ looksdata.remark }}</span>
      </p>

      <p style="color: rgb(73, 73, 73);margin-top: 20px;margin-left: 20px;">
        帖子类型: 
        <span style="color: #000;font-weight: 700;">{{ looksdata.type == 1?'发帖':'活动同步'  }}</span>
      </p>
      <p style="color: rgb(73, 73, 73);margin-top: 20px;margin-left: 20px;">发起人: <span style="color: #000;font-weight: 700;margin-left: 14px;">{{ looksdata.creator }}</span></p>

      <p style="color: rgb(73, 73, 73);margin-top: 20px;margin-left: 20px;">
        发起时间: 
        <span style="color: #000;font-weight: 700;">{{ looksdata.createTime }}</span>
      </p>

      <p style="color: rgb(73, 73, 73);margin-left: 20px;margin-top: 20px;height: 100px;position: relative;">
        <span style="position: absolute;top: 0px;left: 0px;">帖子封面: </span>
        <img style="width: 120px;height: 80px;position: relative;top: 0px;left: 70px;" :src="looksdata.cover" alt="">
      </p>

      <p style="color: rgb(73, 73, 73);margin-left: 20px;margin-top: 20px;height: 190px;position: relative;">
        <span style="position: absolute;top: 0px;left: 0px;">图片内容: </span>
        <ul style="position: relative;top: 0px;left: 50px;">
          <li style="float: left;margin-left: 20px;" v-for="(item,i) in looksdata.contentPic" :key="i">
            <img v-if="item.materialStates == 0" style="width: 120px;height: 80px;" :src="item.materialPath" alt="">
          </li>
        </ul>
      </p>

      <!-- <p style="color: rgb(73, 73, 73);margin-top: 20px;margin-left: 20px;position: relative;">
        <span  style="position:absolute;top:0px;left:0px;">视频内容: </span>
        <video style="position:relative;top:0px;left:70px;" width="220" height="140" controls>
          <source :src="materialPath" type="video/mp4"/>
          <source :src="materialPath" type="video/avi"/>
          <source :src="materialPath" type="video/mov"/>
        </video>
      </p> -->

      <div v-if="activeName == 'first'">
        <el-button @click="pasfun(1)" type="primary" style="margin-top: 40px;margin-left: 315px;">通过</el-button>
        <el-button @click="pasfun(2)" type="primary">不通过</el-button>
      </div>

      <div v-else>
        <p style="color: rgb(73, 73, 73);margin-top: 20px;margin-left: 20px;">审批状态: <span style="color: #000;font-weight: 700;">{{ looksdata.auditStatus == 1 ? '审核通过' : looksdata.auditStatus == 0 ? '审核中' : '审核不通过' }}</span></p>

        <p style="color: rgb(73, 73, 73);margin-top: 20px;margin-left: 20px;">审核人: <span style="color: #000;font-weight: 700;">{{ looksdata.name }}</span></p>
        <el-button @click="dialogVisible = false" style="margin-top: 40px;margin-left: 315px;" type="primary">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formInline: {
        contentName: '',//帖子名称
        creator: '',//创建者
        createTime: '',//创建时间
        pageSize: '10',
        pageIndex: 1,
        itemName: '',//帖子栏目名称（帖子类型）
      },
      formInline2: {
        contentName: '',//帖子名称
        creator: '',//创建者
        createTime: '',//创建时间
        pageSize: '10',
        pageIndex: 1,
        itemName: '',//帖子栏目名称（帖子类型）
      },
      Counts:0,
      Counts2:0,
      activeName: 'first',
      loading: true,
      loading2: true,
      tableData: [],//待处理列表
      tableData2: [],//往期记录列表
      Selectlist: [],//通过和拒绝的数据
      looksdata: '',//查看的数据
      dialogVisible: false,//查看控制
      materialPath:'',//视频地址
      contentKeys: ''//帖子编号
    };
  },
  created() {

  },
  methods: {
    pasfun(auditStatus) {
      var from = {contentKeys: [this.contentKeys],auditStatus: auditStatus}
      this.$Http_Post("/activitymanagement/auditcontent", {from: from}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.dialogVisible = false;
          this.getcurrentcontentlist();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    passfun(auditStatus) {
      var from = {contentKeys: this.Selectlist,auditStatus: auditStatus}
      this.$Http_Post("/activitymanagement/auditcontent",{from: from}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.getcurrentcontentlist();
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    looks(row) {
      this.contentKeys = row.contentKey;
      var from = {contentKey: row.contentKey}
      this.$Http_Post("/activitymanagement/fxcontent", {from: from}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.looksdata = res.Data;
          this.looksdata.contentPic.forEach(item => {
            if (item.materialStates == 1) {
              this.materialPath = item.materialPath
            }
          })
          this.dialogVisible = true;
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    onSubmit() {
      this.getcurrentcontentlist();
    },

    chongzhi(){
      this.formInline = {
        contentName: '',//帖子名称
        creator: '',//创建者
        createTime: '',//创建时间
        pageSize: '10',
        pageIndex: 1,
        itemName: '',//帖子栏目名称（帖子类型）
      }
      
      this.getcurrentcontentlist();
      
    },
    chongzhi2(){
      this.formInline2 = {
        contentName: '',//帖子名称
        creator: '',//创建者
        createTime: '',//创建时间
        pageSize: '10',
        pageIndex: 1,
        itemName: '',//帖子栏目名称（帖子类型）
      }
      this.getpastcontentlist();
    },
    onSubmit2() {
      this.getpastcontentlist();
    },
    handleClick(val) {
      if (this.activeName == 'second') {
        this.getpastcontentlist();
      } else if (this.activeName == 'first') {
        this.getcurrentcontentlist();
      }
    },
    getcurrentcontentlist() {//待处理列表
      this.$Http_Post("/activitymanagement/getcurrentcontentlist", {from: this.formInline}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loading = false;
          this.tableData = res.Data;
          this.Counts = res.Counts;
        }
      });
    },

    getpastcontentlist() {//往期列表
      this.$Http_Post("/activitymanagement/getpastcontentlist", {from: this.formInline2}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loading2 = false;
          this.tableData2 = res.Data;
          this.Counts2 = res.Counts;
        }
      });
    },

    handleSelectionChange(val) {
      var lsc = [];
      for (var i = 0; i < val.length; i++) {
        lsc.push(val[i].contentKey);
      }
      this.Selectlist = lsc;
    },

    handleCurrentChange(val) {
      this.formInline.pageIndex = val;
      this.getcurrentcontentlist();
    },

    handleCurrentChange2(val) {
      this.formInline2.pageIndex = val;
      this.getpastcontentlist();
    },

    handleClose(done) {
      this.$confirm('确认关闭？')
      .then(_ => {
        done();
      })
      .catch(_ => { });
    }

  },
  mounted() {
    this.getcurrentcontentlist();
  },
};
</script>
<style>
  .ExamineInvitation{width: 100%;height: 100%;background-color: #fff;}
  .ExamineInvitation .list-cnt{width: 100%;height: 100%;background-color: #fff;}
  .ExamineInvitation .el-tabs__header{width: 98%;margin-left: 1%;}
</style>
